
import React from 'react';
import { ShieldAlert, Zap } from 'lucide-react';

interface DangerAlertProps {
  isVisible: boolean;
  distance: number;
  type: string;
}

const DangerAlert: React.FC<DangerAlertProps & { theme: any }> = ({ isVisible, distance, type, theme }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center pointer-events-none">
      {/* Flashing Background Overlay */}
      <div className="absolute inset-0 animate-[pulse_0.5s_ease-in-out_infinite] border-[12px]" style={{ backgroundColor: `${theme.danger}33`, borderColor: `${theme.danger}66` }}></div>
      
      {/* Alert Content */}
      <div className="relative bg-black/90 p-8 rounded-sm flex flex-col items-center gap-6 animate-bounce pointer-events-auto border-2" style={{ borderColor: theme.danger, boxShadow: `0 0 50px ${theme.danger}cc` }}>
        <div className="flex gap-4 items-center">
          <div className="p-4 rounded-sm animate-ping absolute opacity-50" style={{ backgroundColor: theme.danger }}></div>
          <div className="p-4 rounded-sm relative" style={{ backgroundColor: theme.danger }}>
            <ShieldAlert size={48} className="text-black" />
          </div>
        </div>
        
        <div className="text-center">
          <h2 className="font-orbitron text-3xl font-black tracking-tighter mb-2" style={{ color: theme.danger }}>
            PROXIMITY WARNING
          </h2>
          <div className="flex items-center justify-center gap-2 px-4 py-1 rounded-sm border mb-4" style={{ backgroundColor: `${theme.danger}33`, borderColor: `${theme.danger}80` }}>
            <Zap size={14} style={{ color: theme.danger }} />
            <span className="text-xs font-bold uppercase tracking-widest" style={{ color: theme.danger }}>PERIMETER BREACH</span>
          </div>
          <p className="text-amber-500 text-lg font-mono font-bold uppercase mb-1">
            {type} DETECTED
          </p>
          <p className="text-2xl font-black font-mono" style={{ color: theme.danger }}>
            {(distance * 5280).toFixed(0)} FEET
          </p>
        </div>

        <div className="w-full h-1 bg-stone-900 rounded-sm overflow-hidden">
          <div className="h-full animate-[loading_1s_linear_infinite]" style={{ width: '40%', backgroundColor: theme.danger }}></div>
        </div>
        
        <p className="text-[10px] text-amber-400 font-mono text-center uppercase tracking-widest">
          Neural Radar confirms active law enforcement engagement<br/>
          Avoid the area immediately
        </p>
      </div>

      <style>{`
        @keyframes loading {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(250%); }
        }
      `}</style>
    </div>
  );
};

export default DangerAlert;
